// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"cbbbd797","981":"295287b9"}[chunkId] + ".chunk.css";
};